import { TAdminUsersResponse } from '@mybonum/api';

import { TCustomerType } from '@/modules/customers/types.ts';

export const normalizeData = (data: TAdminUsersResponse['result']): TCustomerType[] =>
    data.map((item) => ({
        id: item.id,
        email: item.email,
        createdDate: item.created_date,
        firstName: item.first_name,
        lastName: item.last_name,
        patients: item.patient_count,
        totalAppointments: item.appointment_count,
        totalSearches: item.search_count,
        phone: item.phone,
    }));
